export default "__VITE_ASSET__CaFDuaSw__"